import { FC, useState, ComponentType } from "react"
import { useChallenge } from "../../stores/challenge"
import { ListUsersSubscriptionsResponseItem, ListTeamsSubscriptionsResponseItem, Task } from "../../sdk"
import TaskSubmissions from "./TaskSubmissions"
import classNames from "classnames"
import Icon from "../Icon"

export type TaskSubmissionsProps = {
  task: Task
}

const ChallengeSubscription: FC = () => {
  const tasks = useChallenge(({ tasks }) => tasks)
  const challenge = useChallenge(state => state.challenge)
  const setSubscriptionsTableVisible = useChallenge(state => state.setSubscriptionsTableVisible)
  const currentOpenSubscription = useChallenge(state => state.currentOpenSubscription)

  const tasksIds: string[] = tasks?.map(({ alias }) => alias) || [""]

  type SectionId = typeof tasksIds[number]

  type Section = {
    id: SectionId
    label: string
    component: ComponentType<TaskSubmissionsProps>
  }

  const sections: Section[] | null = tasks?.map(({ alias, title }) => {
    return {
      id: alias,
      label: title,
      component: TaskSubmissions
    }
  }) || null

  const [activeSection, setActiveSection] = useState<SectionId>(tasksIds[0])

  return (
    <>
      <ul className="tabs__nav">
        <li>
          <span
            className="flex items-center"
          >
            <span
              onClick={(): void => {
                setSubscriptionsTableVisible(true)
              }}
            >
              <Icon name="arrow-up-circle" className="-rotate-90 text-gray-500 hover:cursor-pointer" size={30} />
            </span>

            {currentOpenSubscription &&
              challenge?.individual ?
              <h2 className="mx-3 text-lg text-indigo-700 font-bold">{(currentOpenSubscription as ListUsersSubscriptionsResponseItem).user.username}</h2>
              :
              <h2 className="mx-3 text-lg text-indigo-700 font-bold">{(currentOpenSubscription as ListTeamsSubscriptionsResponseItem)?.team?.name}</h2>
            }
          </span>
        </li>
        {sections && sections.map((section) => (
          <li
            key={section.id}
            className={classNames("tabs__item", section.id === activeSection && "tabs__item--active")}
            onClick={(): void => setActiveSection(section.id)}
          >
            {section.label}
          </li>
        ))}
      </ul>

      {tasks && tasks.find(({ alias }) => alias === activeSection) &&
        <TaskSubmissions task={tasks.find(({ alias }) => alias === activeSection)!} />
      }
    </>
  )
}

export default ChallengeSubscription
